import { useCallback, useEffect, useState } from 'react'

const useBodyScroll = () => {
  const [bodyScroll, setBodyScroll] = useState<boolean>(true)
  const [scrollBarCompensation, setScrollBarCompensation] = useState(0)

  useEffect(() => {
    const sbc = window.innerWidth - document.body.offsetWidth
    setScrollBarCompensation(sbc)

    if (!bodyScroll) {
      document.body.style.paddingRight = `${sbc}px`
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.style.paddingRight = '0px'
      document.body.classList.remove('overflow-hidden')
    }

    return () => {
      document.body.style.paddingRight = '0px'
      document.body.classList.remove('overflow-hidden')
    }
  }, [bodyScroll])

  const enable = useCallback(() => {
    setBodyScroll(true)
  }, [])

  const disable = useCallback(() => {
    setBodyScroll(false)
  }, [])

  return {
    enable,
    disable,
    scrollBarCompensation,
    enabled: bodyScroll,
  }
}

export default useBodyScroll
